//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import qs from 'qs';
import {debounce} from "debounce";
import businessMoment from "moment-business-days";
import CartItem from "@/components/profile/CartItem";

export default {
  name: "CartComponent",
  components: {
    CartItem
  },
  props: {
    needClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    openCatalog() {
      if ((this.$route.path === '/catalog' || this.$route.path === '/catalog/') && !Object.keys(this.$route.query).length) {
        this.close();
      } else {
        this.$router.push('/catalog');
      }
    },
    debItemCount: debounce(function (item) {
      const options = item.options || {};
      if (options.engraving_upload) {
        options.engraving_upload = JSON.stringify(options.engraving_upload);
      }
      let optionList = {};
      for (let key in options) {
        optionList[`options[${key}]`] = options[key];
      }
      const params = {
        cart_unique_id: this.cartId,
        quantity: item.quantity,
        //options,
        ...optionList
      }
      this.loading = true;
      this.$axios.patch(`/carts/items/${item.id}`, qs.stringify(params), {headers: {'Authorization': this.userInfo ? `Bearer ${this.userInfo.access_token.token}` : null}})
        .then(async res => {
          res.data?.data?.cart?.items?.forEach(item => {
            if (item.options.engraving_upload) {
              item.options.engraving_upload = JSON.parse(item.options.engraving_upload);
            }
          });
          this.$store.commit('setStoreVar', {var: 'cart', val: res.data.data.cart.items});
          await this.$store.dispatch('getCart');
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        })
    }, 700),
    removeIncludedPackageWrap(item) {
      this.loading = true;
      let options = {
        ...item.options,
        package_wrap_id: null
      };
      if (options.engraving_upload) {
        options.engraving_upload = JSON.stringify(options.engraving_upload);
      }
      let optionList = {};
      for (let key in options) {
        optionList[`options[${key}]`] = options[key];
      }
      const params = {
        cart_unique_id: this.cartId,
        //options,
        ...optionList
      }
      this.$axios.patch(`/carts/items/${item.id}`, qs.stringify(params), {headers: {'Authorization': this.userInfo ? `Bearer ${this.userInfo.access_token.token}` : null}})
          .then(res => {
            res.data?.data?.cart?.items?.forEach(item => {
              if (item.options.engraving_upload) {
                item.options.engraving_upload = JSON.parse(item.options.engraving_upload);
              }
            });
            this.$store.commit('setStoreVar', {var: 'cart', val: res.data.data.cart.items});
          })
          .catch(err => {
            console.log(err);
          })
          .then(() => {
            this.loading = false;
          })
    },
    removeIncludedPackage(item) {
      this.loading = true;
      let options = {};
      if (item.options) {
        options = JSON.parse(JSON.stringify(item.options));
        delete options.package_id;
        delete options.package_image_id;
        delete options.package_label;
        delete options.package_type;
        delete options.package_wrap_id;
      }
      if (options.engraving_upload) {
        options.engraving_upload = JSON.stringify(options.engraving_upload);
      }
      let optionList = {};
      for (let key in options) {
        optionList[`options[${key}]`] = options[key];
      }
      const params = {
        cart_unique_id: this.cartId,
        //options,
        ...optionList
      }
      this.$axios.patch(`/carts/items/${item.id}`, qs.stringify(params), {headers: {'Authorization': this.userInfo ? `Bearer ${this.userInfo.access_token.token}` : null}})
        .then(res => {
          res.data?.data?.cart?.items?.forEach(item => {
            if (item.options.engraving_upload) {
              item.options.engraving_upload = JSON.parse(item.options.engraving_upload);
            }
          });
          this.$store.commit('setStoreVar', {var: 'cart', val: res.data.data.cart.items});
        })
        .catch(err => {
          console.log(err);
        })
        .then(() => {
          this.loading = false;
        })
    },
    remove(item) {
      const params = {
        cart_unique_id: this.cartId,
      }
      this.$axios.delete(`/carts/items/${item.id}`, {
        headers: {'Authorization': this.userInfo ? `Bearer ${this.userInfo.access_token.token}` : null},
        params
      })
        .then(res => {
          const items = this.items.filter(i => i.id !== item.id);
          this.$store.commit('setStoreVar', {var: 'cart', val: items});
          this.$store.dispatch('getCart');
          this.loading = false;
        })
    },
    close() {
      document.querySelector('#cart-modal').classList.remove('open-cart');
      setTimeout(() => {
        this.$store.commit('setStoreVar', {var: 'cartModal', val: false})
      }, 500)
    },
    checkout() {
      this.$router.push('/checkout');
    }
  },
  computed: {
    isDigitalGiftCard() {
      return this.items.some(item => item.configuration_id === this.$store.getters.getGiftCardVendorModels.digital) && !this.items.some(item => item.configuration_id !== this.$store.getters.getGiftCardVendorModels.digital);
    },
    isPhysicalGiftCard() {
      return this.items.some(item => item.configuration_id === this.$store.getters.getGiftCardVendorModels.physical) && !this.items.some(item => item.configuration_id !== this.$store.getters.getGiftCardVendorModels.physical && item.configuration_id !== this.$store.getters.getGiftCardVendorModels.digital);
    },
    isRingSizer() {
      return this.items.some(item => item.configuration_id === this.$store.getters.getRingSizerVendorModel)
        && !this.items.some(item => item.configuration_id !== this.$store.getters.getRingSizerVendorModel && item.configuration_id !== this.$store.getters.getGiftCardVendorModels.physical && item.configuration_id !== this.$store.getters.getGiftCardVendorModels.digital);
    },
    estimatedArrival() {
      let arrivalDays = 14;
      if (this.isPhysicalGiftCard) {
        arrivalDays = 2;
      }
      if (this.isRingSizer) {
        arrivalDays = 7;
      }
      return businessMoment ? businessMoment(new Date()).businessAdd(arrivalDays).format('MMMM DD') : '';
    },
    cartInfo() {
      return this.$store.getters.getCartInfo
    },
    subtotal() {
      let s = 0;
      this.items.forEach(item => {
        s = s + item.cost * (item.quantity ? item.quantity : 1)
      })
      return s.toFixed(0)
    },
    userInfo() {
      return this.$store.getters.getUserInfo
    },
    cartModal() {
      return this.$store.getters.getCartModal
    },
    cartId() {
      return this.$store.getters.getCartId
    },
    items() {
      return this.$store.getters.getCartItems ? JSON.parse(JSON.stringify(this.$store.getters.getCartItems)) : []
    },
  },
  mounted() {
    let isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (isSafari && iOS) {
      let baseWindowHeight = Math.max(window.innerHeight);
      let classAdded = false;
      let documentBody = document.body;
      documentBody.classList.add("ios-toolbar");
      document.addEventListener('scroll', function (e) {
        var newWindowHeight = Math.max(window.innerHeight);
        if (newWindowHeight - 50 > baseWindowHeight) {
          if (!documentBody.classList.contains("ios-toolbar-gone")) {
            documentBody.classList.add("ios-toolbar-gone");
          }
        } else {
          if (documentBody.classList.contains("ios-toolbar-gone")) {
            documentBody.classList.remove("ios-toolbar-gone");
            documentBody.classList.add("ios-toolbar");
          }
        }
      });
    }

    let ua = navigator.userAgent.toLowerCase();
    let isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
    if (isAndroid) {
      let documentBody = document.body;
      documentBody.classList.add("android-toolbar");
    }
  }
}
